export function CartItemBadges({
  hasConsultation,
}: {
  hasConsultation: boolean;
}) {
  return (
    <>
      {hasConsultation && (
        <p className="text-sm text-fg-neutral-strong">
          This item is subject to medical approval from a pharmacist.
        </p>
      )}
    </>
  );
}
